import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class PackageCategoryService {

    static getpackageCategory(item) {

        let api = `${API_BASE_URL}${API_PATHS.getpackageCategory}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addpackageCategory(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addpackageCategory}`;
        return axiosInstance
            .post(api, data)

    }

    static editpackageCategory(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editpackageCategory}`;
        return axiosInstance
            .put(api, data)

    }

    static deletepackageCategory(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deletepackageCategory}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default PackageCategoryService;
